module.exports = __webpack_public_path__ + "static/media/rectangle.9e6a47c8.svg";